import React, { useState, useEffect, Fragment } from "react";

import { Link, useLocation } from "react-router-dom";
import "../i18n/config";
import i18next from "i18next";
import { Row, Col, Collapse, Button, Image } from "react-bootstrap";
import * as moment from 'moment';
import NumberFormat from 'react-number-format';
import apiService from "../services/api.service";
import { selectCartItems, selectCompanyData } from "../Redux/shoppingCartReducer";
import { useSelector } from "react-redux";
import Select from 'react-select'
import CompanyProductSummaryMobile from "../components/CompanyComponents/CompanyProductSummaryMobile";
import CompanyProductSummaryDesktop from "../components/CompanyComponents/CompanyProductSummaryDesktop";
import ProductPriceComponent from "./ProductPriceComponent";
import { useTranslation } from "../hooks/useTranslation";
import { ProductType } from "../data/enums";
import useMobileScreen from "./useMobileScreen";

function ShoppingCartItemComponent(props) {

  const [lang, setLang] = useState("");
  const [isOpenMoreDetails, setIsOpenMoreDetails] = useState(false);
  const orderNUm = sessionStorage.getItem("lastOrderNum") || 0;
  const [myOrder, setmyOrder] = useState("");
  const companyUser = useSelector((state) => state.company.companyUser)
  const { t } = useTranslation();
  const location = useLocation();
  let cartItems = useSelector(selectCartItems);
  const productsFromSession = window.sessionStorage.getItem("products");
  cartItems = productsFromSession ? JSON.parse(productsFromSession) : cartItems;
  let currencyCode = Object.values(cartItems)[0]?.selectedProduct.currencyCode || ""
  const [selectedWorkers, setSelectedWorkers] = useState([])
  const workers = useSelector((state) => state.company.workers)
  const cartCompanyData = useSelector(selectCompanyData);
  const isMobile = useMobileScreen();

  const SetLanguage = (l) => {
    i18next.changeLanguage(l);
  };

  useEffect(() => {
    if (workers) {
      let workersParsed = []
      workers.map((worker) => {
        workersParsed.push({
          value: worker.companyWorkerId, label: worker.workerFirstName + " " + worker.workerLastName,
        })
      })
      setSelectedWorkers(workersParsed)
    }
  }, [])

  useEffect(() => {
    setLang(new URLSearchParams(location.search).get("lang") || "eng");
    if (props.isConfirmation) {
      getMyOrder(orderNUm);
    }
  }, []);

  useEffect(() => {
    SetLanguage(lang);
  }, [lang]);

  const getProductTranslations = (prod) => {
    if (prod && prod.translations) {
      let ProductTranslations = prod.translations.filter((p) => {
        return p.languageIsoCode == lang && p.propductId == prod.propductId;
      });
      return ProductTranslations.length > 0 ? ProductTranslations[0] : {};
    }
    return {};
  };

  const addDays = (date, days) => {
    var result = new Date(date);
    result.setDate(result.getDate() + days);
    return moment(result).format('DD/MM/YYYY');
  }
  const getQty = () => {
    if (companyUser) {
      return props.currentItem.qty
    }
    return props.currentItem.qty > 1 ? " × " + props.currentItem.qty : "";
  }
  const getProdName = () => {
    return getProductTranslations(props.currentProduct).productName ? getProductTranslations(props.currentProduct).productName : props.currentProduct.productName;
  }
  const getMyOrder = (orderId) => {
    apiService.getOrders({ orderId: orderId })
      .then(
        (response) => {
          if (response.data && response.data.data && response.data.data.length > 0) {
            setmyOrder(response.data.data[0])
          }
        },
        (error) => {
          const _content =
            (error.response &&
              error.response.data &&
              error.response.data.message) ||
            error.message ||
            error.toString();
        }
      );
  };

  const getTotalPrice = () => {
    let price = 0
    {
      Object.keys(cartItems).map((k, ind) => {
        const currentItem = cartItems[k];
        price += currentItem.selectedProduct.productPriceAfterDiscount * currentItem.qty
      })
    }
    return price
  }

  const getCurrency = () => {
    return props.currentProduct.currencyCode
      ? props.currentProduct.currencyCode.replace("ILS", "₪")
      : props.currentProduct.currencyCode
  }
  const getImageAlt = (image) => {
    if (image && image.translations && image.translations.length) {
      return image.translations[0].imageDescription;
    }
    return "";
  }
  const getImageTitle = (image) => {
    if (image && image.translations && image.translations.length) {
      return image.translations[0].imageTitle;
    }
    return "";
  }
  return (
    <>
      {
        props.isConfirmation ?
          <Row>
            <Col className="expdate">
              {
                props.currentProduct.productTypeId === ProductType.PackageSpecDates
                  ? t("ValidOn")
                  : t("ExpDate")
              }
              {
                // Display the date range for PackageSpecDates products, or the expiry date for other products
                props.currentProduct.productTypeId === ProductType.PackageSpecDates && props.currentProduct?.dates?.length > 0 &&
                  <span> {moment(props.currentProduct.dates[0].fromDate).format("DD/MM/YYYY")} - {moment(props.currentProduct.dates[0].toDate).format("DD/MM/YYYY")}</span>
              }
              <span> {props.currentProduct.duration && myOrder && myOrder.orderPlacementDate ? addDays(myOrder.orderPlacementDate, props.currentProduct.duration) : props.currentProduct.expiryDate ? moment(props.currentProduct.expiryDate).format('DD/MM/YYYY') : ""} </span>
            </Col>
          </Row> : null
      }
      {
        companyUser ?
          <>
            <CompanyProductSummaryMobile
              getProdName={getProdName}
              getCurrency={getCurrency}
              currencyCode={currencyCode}
              itemCount={props.itemCount}
              getTotalPrice={getTotalPrice}
              currentProduct={props.currentProduct}
            />
            {
              selectedWorkers.length > 0 &&
              <div className="mb-4 hidden-desk">
                <span>{t("YouSelectedToSend")}</span>
                <Select
                  id="select-worker"
                  className="select-workers disabled-options"
                  options={selectedWorkers}
                  isSearchable={false}
                  value={t("YouChose") + " " + selectedWorkers.length + " " + t("Recipients")}
                  placeholder={t("YouChose") + " " + selectedWorkers.length + " " + t("Recipients")}
                  theme={(theme) => ({
                    ...theme,
                    borderRadius: 3,
                    colors: {
                      ...theme.colors,
                      primary25: 'white',
                      primary: '#5A687E',
                      primary50: 'white',
                    },
                  })}
                />
              </div>
            }
            <CompanyProductSummaryDesktop
              getProdName={getProdName}
              getCurrency={getCurrency}
              currencyCode={currencyCode}
              itemCount={props.itemCount}
              getTotalPrice={getTotalPrice}
              currentProduct={props.currentProduct}
            />
            {selectedWorkers.length > 0 &&
              <div className="d-flex justify-content-end hidden-mobile">
                <div className="w-50 pe-4">
                  <span>{t("YouSelectedToSend")}</span>
                  <div>
                    <Select
                      readOnly
                      id="select-worker"
                      className="select-workers disabled-options"
                      options={selectedWorkers}
                      isSearchable={false}
                      value={t("YouChose") + " " + selectedWorkers.length + " " + t("Recipients")}
                      placeholder={t("YouChose") + " " + selectedWorkers.length + " " + t("Recipients")}
                      theme={(theme) => ({
                        ...theme,
                        borderRadius: 3,
                        colors: {
                          ...theme.colors,
                          primary25: 'white',
                          primary: '#5A687E',
                          primary50: 'white',
                        },
                      })}
                    />
                  </div>
                </div>
              </div>
            }
            {
              cartCompanyData?.greetingText &&
                <div className="cart-greetings-wrapper d-flex justify-content-end">
                  <div className={`cart-greetings ${!isMobile ? 'w-50 pe-4' : ''}`}>
                    <div className="cart-greetings-title">{t("CartGreetingsTitle")}</div>
                    <div className="cart-greetings-message">
                      {cartCompanyData.greetingText}
                    </div>
                  </div>
                </div>
            }
          </>
          :
          <Fragment>
            {        
                <Row key={`item-${props.currentProduct.productId}`} className={"shop-item " + props.topCart ? "top-cart" : ""}>
                  {/* product image */}
                  {!props.isConfirmation &&
                    <Col className="position-relative">
                      {!!props.currentProduct.images &&
                        <Image className="gift-img"
                          alt={getImageAlt(props.currentProduct?.images[0])}
                          title={getImageTitle(props.currentProduct?.images[0])}
                          src={props.currentProduct.images[0]?.fullURL} />
                      }
                      <div className="float-price hidden-desk">
                        <ProductPriceComponent
                          product={props.currentProduct}
                          multiply={props.currentItem.qty}
                        />
                      </div>
                    </Col>
                  }
                  {/* product name and description */}
                  <Col lg={7}>
                    <Fragment>
                      <h3 className="name" aria-label={getProdName()}>{getProdName()} {getQty()}</h3>
                      <span>{getProductTranslations(props.currentProduct)?.productShortDescription}</span>
                      {
                        !!getProductTranslations(props.currentProduct).productDescription &&
                          <div className="more-info">
                            <Button variant="link" onClick={() => setIsOpenMoreDetails(!isOpenMoreDetails)}
                              aria-controls={`collapse-moreinfo-${props.currentProduct.productId}`}
                              aria-expanded={isOpenMoreDetails}
                                  >
                              {!isOpenMoreDetails ? t("MoreInfo") : t("Close")}
                            </Button>
                          </div>
                      }
                    </Fragment>
                  </Col>
                  {/* product price */}
                  <Col>
                    <ProductPriceComponent
                      product={props.currentProduct}
                      multiply={props.currentItem.qty}
                    />
                  </Col>
                </Row>
            }

            <Row>
              <Col>
                {
                  <Collapse in={isOpenMoreDetails || props.isConfirmation}>
                    <div id={`collapse-moreinfo-${props.currentProduct.productId}`} className="collapse-info">
                      <span dangerouslySetInnerHTML={{ __html: getProductTranslations(props.currentProduct)?.productDescription }}></span>
                    </div>
                  </Collapse>
                }
              </Col>
            </Row>
          </Fragment>
      }
    </>
  );
}

export default ShoppingCartItemComponent;
